<div
  class="w-100 d-flex justify-content-center align-items-center margin-top-24"
>
  <kehe-phoenix-globe-spinner></kehe-phoenix-globe-spinner>
</div>
